import { render, staticRenderFns } from "./recommendCircle.vue?vue&type=template&id=52178f64&scoped=true&"
import script from "./recommendCircle.vue?vue&type=script&lang=js&"
export * from "./recommendCircle.vue?vue&type=script&lang=js&"
import style0 from "./recommendCircle.vue?vue&type=style&index=0&id=52178f64&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52178f64",
  null
  
)

export default component.exports